<template>
  <IQOS title="Вартість доставки" required>
    <div class="mt-16">
      <BaseTabSwitcher 
        fullWidth 
        :value="cafe.delivery.taxi_payer"
        @input="setPayer"
        :tabs="[
        {
          text: $t('moeco_partner.payer_client'),
          value: 'client'
        },
        {
          text: $t('moeco_partner.payer_cafe'),
          value: 'cafe'
        },
        {
          text: $t('moeco_partner.payer_conditional'),
          value: 'conditional'
        }
        ]" />

    </div>

    <div v-if="cafe.delivery.taxi_payer == 'conditional'">
      <div class="conditions-table iqos-group-item" v-if="editing || cost_min_checks.length">
        <div class="conditions-table-row mt-16" v-for="(item,index) in cost_min_checks" :key="index">
          <BaseInput 
            class="conditions-table-input w-100"
            type="number" 
            :placeholder="$t('taxi_price_panel.limit_ph')" 
            v-model.number="cost_min_checks[index].limit"
            :disabled="!editing"
            :valid="valid || item.limit > 0"/>
          <BaseInput 
            type="number"
            class="conditions-table-input w-100" 
            :placeholder="$t('taxi_price_panel.price_ph')" 
            v-model.number="cost_min_checks[index].price"
            :valid="valid || item.price"
            :disabled="!editing"/>
          <BaseButton variant="secondary" icon="trash" size="md" color="red-4"  @click="cost_min_checks.splice(index,1)"  v-if="editing"/>
        </div>
        <BaseButton class="mt-16 w-100" size="md" variant="secondary" @click="addCostCondition" v-if="editing && cost_min_checks.length < 5">
          {{ $t('taxi_price_panel.add_button') }}
        </BaseButton>
      </div>
      <!-- <BaseInput
        type="number"
        class="iqos-group-item"
        @blur="saveMinCheck"
        v-model.number="cost_min_check"
        :readonly="!editing"
        placeholder="100"
      /> -->
      <p class="iqos-comment mt-16">{{ $t('moeco_partner.conditional_desc') }}</p>
      <p class="iqos-comment mt-16">{{ $t('moeco_partner.conditional_example') }}</p>
    </div>

    <template #actions>
    <IQOSActions
      :editing="editing"
      @edit="showEditUI"
      @cancel="hideEditUI"
      @accept="saveChanges"
    />
    </template>
  </IQOS>
</template>

<script>
import SlideToggleRow from "@/components/SlideToggleRow"

export default {
  data() {
    return {
      editing: false,

      valid: true,

      cost_min_check: 0,
      cost_min_checks: []
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    setPayer(value) {
      if (!this.editing) return;
      this.$store.commit("setDeliveryTaxiPayer", value);
    },
    saveChanges() {
      if (this.cafe.delivery.taxi_payer == 'conditional' && (!this.cost_min_checks || !this.cost_min_checks.length || !this.cost_min_checks[0].price)) {
        this.valid = false;
        return;
      }

      const invalid_item = this.cost_min_checks.find(a => !a.limit || !a.price || a.limit <= 0 || a.price < 0);

      if (invalid_item) {
        this.valid = false;
        return;
      }

      this.valid = true;
      // this.$store.commit("setDeliveryCostMinCheck", this.cost_min_check);
      this.$store.commit('setDeliveryCostMinChecks', this.cost_min_checks);
      this.$store.dispatch("saveCafe");

      this.editing = false;
    },
    reset() {
      this.cost_min_check = this.cafe.delivery.cost_min_check || null;
      this.cost_min_checks = this.cafe.delivery.cost_min_checks || [];
      this.valid = true;
    },
    addCostCondition() {
      this.cost_min_checks.push({
        limit: null,
        price: null
      });
    }
  },
  mounted() {
    this.reset();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
  components: {
    SlideToggleRow
  },
};
</script>

<style scoped>
.conditions-table-row {
  display: flex;
  align-items: center;
  align-self: center;
}

.icon-delete {
  display: block;
  cursor: pointer;
  height: 3.5vh;
  width: auto;
}

.conditions-table-input {
  margin-right: 1vh;
}
</style>